import React from 'react';
import ReactGA from 'react-ga';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import ReviewPayment from './pages/ReviewPayment';
import OrderSuccess from './pages/PaymentSuccess';
import OrderNotFound from './pages/OrderNotFound';
import ErrorOnPayment from './pages/ErrorOnPayment';
import MethodError from './pages/MethodError';
import Boleto from './pages/Boleto';
import Receipt from './pages/Receipt';
import Order from './pages/Order';
import ProductOutOfStock from './pages/ProductOutOfStock';
import OrderCanceled from './pages/OrderCanceled';
import BoletoExpired from './pages/BoletoExpired';
import Pix from './pages/Pix';
import PixExpired from './pages/PixExpired';
import SaleNotAllowed from './pages/SaleNotAllowed';
import SellerDoesNotSellToCnpj from './pages/SellerDoesNotSellToCnpj';
import AuthorizationTerm from './pages/AuthorizationTerm';

// Initialize google analytics page view tracking
const history = createBrowserHistory();
history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const Routes = () => (
  <Router history={history}>
    <Switch>
      <Route
        exact
        path="/:id/pagamento-realizado-com-sucesso"
        component={OrderSuccess}
      />
      <Route exact path="/:id/metodo-invalido" component={MethodError} />
      <Route
        exact
        path="/:id/pedido-nao-encontrado"
        component={OrderNotFound}
      />
      <Route exact path="/:id/erro-no-pagamento" component={ErrorOnPayment} />
      <Route
        exact
        path="/:id/produto-sem-estoque"
        component={ProductOutOfStock}
      />
      <Route exact path="/:id/pedido-cancelado" component={OrderCanceled} />
      <Route exact path="/:id" component={Order} />
      <Route exact path="/:id/:document/revisao" component={ReviewPayment} />
      <Route exact path="/:id/comprovante" component={Receipt} />
      <Route exact path="/:id/:document/boleto" component={Boleto} />
      <Route exact path="/:id/boleto-expirado" component={BoletoExpired} />
      <Route exact path="/:id/:document/pix" component={Pix} />
      <Route exact path="/:id/pix-expirado" component={PixExpired} />
      <Route exact path="/:id/venda-nao-permitida" component={SaleNotAllowed} />
      <Route exact path="/:id/seller-nao-aceita-venda-para-cnpj" component={SellerDoesNotSellToCnpj} />
      <Route exact path="/:id/servico/:serviceId/termo-de-autorizacao" component={AuthorizationTerm} />
    </Switch>
  </Router>
);

export default Routes;
